export const errors = {
  notFound: {
    title: '404',
    heading: 'No Encontrado',
    description: 'La página que buscas no existe.',
    goBack: 'Volver',
    goHome: 'Ir al Inicio',
  },
  forbidden: {
    title: '403',
    heading: 'Prohibido',
    description: 'No tienes permisos para acceder a este recurso.',
    goBack: 'Volver',
    goHome: 'Ir al Inicio',
    organizationDescription: 'Esta organización no existe o no tienes acceso a ella.',
    goToOwnOrganization: 'Ir a mi organización',
  },
} as const
